import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import './CodingTopic.css';
import MultiGallery from './MultiGallery.js';
import WebApps from './WebApps.js';
import CustomButton from './CustomButton.js';

// Import your local images
import AcuScopeImage from './img/AcuScope_ui_002.jpg'; // Adjust path if your image is elsewhere
import MindEntrainerImage from './img/mindEntrainer-banner-01.jpg'; // Adjust path if your image is elsewhere

// Your provided items array for MultiGallery
const items = [
    {
        type: 'image',
        title: 'AcuScope',
        description: 'This VST3/AU plugin provides a dual oscilloscope with Lissajous and waveform displays for precise monitoring and manipulation of stereo imaging using delay and phase adjustments.',
        linkClass: 'image',
        content: AcuScopeImage, // Use the imported image variable
        extras: {
            title: 'Go to product page',
            url: 'https://acusmagic.com/product/acuscope/'
        },
    },
    {
        type: 'youtube',
        title: 'Sonicrama',
        description: 'Synthesizer focused on drawing lissajous patterns with music, crating binaural beats and custom tunings',
        linkClass: 'youtube-video',
        content: 'https://www.youtube.com/watch?v=UkqS2brssYE',
        extras: {
            title: 'Go to product page',
            url: 'https://acusmagic.com/product/sonicrama/'
        },
    },
    {
        type: 'youtube',
        title: 'MultiLFO',
        description: 'Audio Plugin | Combine up to 16 LFOs to give rhythm to your sounds',
        linkClass: 'youtube-video',
        content: 'https://www.youtube.com/watch?v=3GWnRv1TpN4',
        extras: {
            title: 'Go to product page',
            url: 'https://acusmagic.com/product/multilfo/'
        },
    },
    {
        type: 'image',
        title: 'MindEntrainer',
        description: 'MindEntrainer is an app for Android, Windows and Mac osx with which you can create sound patterns for brainwave synchronization.',
        linkClass: 'youtube-video', // This linkClass is misleading, it's an image. You might want to change this if it affects styling.
        content: MindEntrainerImage, // Use the imported image variable
        extras: {
            title: 'Go to product page',
            url: 'https://acusmagic.com/product/mindentrainer/'
        },
    },
    {
        type: 'youtube',
        title: 'Button Designer',
        description: 'a GUI app to design buttons and export C++ code to use inside the JUCE framework',
        linkClass: 'youtube-item',
        content: 'https://www.youtube.com/watch?v=InMbJbOhl7s',
        extras: {
            title: '',
            url: ''
        },
    },
    {
        type: 'youtube',
        title: 'AudioTools',
        description: 'Tool to investigate and learn about different filter designs',
        linkClass: 'youtube-item',
        content: 'https://www.youtube.com/watch?v=onVnK_B7Yo0',
        extras: {
            title: '',
            url: ''
        },
    },
];

function CodingTopic({ 
    acceptedCookieCategories = { essential: true, analytics: false, marketing: false, externalMedia: false },
    onUpdateCookiePreferences = () => {} 
}) {
    // State to hold the responsive scrollMarginTop value
    const [responsiveScrollMargin, setResponsiveScrollMargin] = useState('0rem'); // Initialize with a default or mobile value

    // Effect to determine and update scrollMarginTop based on screen width
    useEffect(() => {
        const updateScrollMargin = () => {
            // Define your desktop and mobile breakpoints and corresponding margins
            const desktopWidth = 768; // Standard breakpoint for md: in Tailwind
            const desktopMargin = '-92rem'; // Your desired desktop offset
            const mobileMargin = '2rem';   // Your desired mobile offset

            if (window.innerWidth >= desktopWidth) {
                setResponsiveScrollMargin(desktopMargin);
            } else {
                setResponsiveScrollMargin(mobileMargin);
            }
        };

        // Set initial margin on mount
        updateScrollMargin();

        // Add event listener for window resize
        window.addEventListener('resize', updateScrollMargin);

        // Clean up event listener on component unmount
        return () => window.removeEventListener('resize', updateScrollMargin);
    }, []); // Empty dependency array means this effect runs once on mount and cleans up on unmount

    // Generic function for smoothly scrolling to any target element ID
    const handleSmoothScroll = (targetId) => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            console.warn(`Target element with ID '${targetId}' not found for smooth scroll.`);
        }
    };

    return (
        <div>
            <div id="description-container">
                <span className="title"></span>
                <span className="content">
                    I develop applications using:<br/>
                    <span className="content-small">C++ | React | JUCE | DSP | CSS | Javascript | PHP | Python</span>
                </span>
            </div>
            <CustomButton onClick={() => handleSmoothScroll('web-apps')}>
                Web Applications
            </CustomButton>
            <MultiGallery 
                items={items} 
                acceptedCookieCategories={acceptedCookieCategories} 
                onUpdateCookiePreferences={onUpdateCookiePreferences} 
            />

            {/*
                This is the target div for the smooth scroll.
                The scrollMarginTop style is now dynamically set based on screen width.
            */}
            <div id="web-apps" style={{ scrollMarginTop: responsiveScrollMargin }}>                
                <WebApps 
                    acceptedCookieCategories={acceptedCookieCategories} 
                    onUpdateCookiePreferences={onUpdateCookiePreferences}
                />
            </div>
        </div>
    );
}

export default CodingTopic;
